import React from "react";
import { cn } from "../lib/utils";

// Sources icon component
const SourcesIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("w-5 h-5", className)}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
    />
  </svg>
);

interface SourcesToggleButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  sourcesCount: number;
}

export const SourcesToggleButton: React.FC<SourcesToggleButtonProps> = ({
  isOpen,
  onToggle,
  sourcesCount,
}) => {
  return (
    <button
      onClick={onToggle}
      className={cn(
        "relative p-2 rounded-md transition-colors",
        "hover:bg-zinc-700/50",
        isOpen ? "bg-emerald-500/20 text-emerald-400" : "text-zinc-400 hover:text-white"
      )}
      title={`${isOpen ? 'Hide' : 'Show'} sources`}
    >
      <SourcesIcon />
      
      {/* Badge showing sources count */}
      {sourcesCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-emerald-500 text-white text-xs font-medium rounded-full flex items-center justify-center">
          {sourcesCount > 99 ? '99+' : sourcesCount}
        </span>
      )}
    </button>
  );
};
